document.addEventListener('DOMContentLoaded', function() {
    initSimpleSearch();
});

function initSimpleSearch() {
    // Crear el icono de búsqueda
    const searchIcon = document.createElement('div');
    searchIcon.className = 'simple-search-icon';
    searchIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${GSEARCH_CONFIG.iconSize}" height="${GSEARCH_CONFIG.iconSize}" viewBox="0 0 24 24" fill="none" stroke="${GSEARCH_CONFIG.iconColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    `;
    
    // Aplicar posicionamiento
    Object.keys(GSEARCH_CONFIG.position).forEach(key => {
        searchIcon.style[key] = GSEARCH_CONFIG.position[key];
    });
    
    // Crear el popup de búsqueda
    const searchPopup = document.createElement('div');
    searchPopup.className = 'simple-search-popup';
    searchPopup.innerHTML = `
        <div class="simple-search-header">
            <input type="text" class="simple-search-input" placeholder="Buscar...">
            <button class="simple-search-submit">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
            </button>
            <button class="simple-search-close">×</button>
        </div>
        <div class="simple-search-results"></div>
    `;
    
    // Añadir elementos al DOM
    document.body.appendChild(searchIcon);
    document.body.appendChild(searchPopup);
    
    // Referencias a los elementos
    const searchInput = searchPopup.querySelector('.simple-search-input');
    const searchSubmit = searchPopup.querySelector('.simple-search-submit');
    const searchClose = searchPopup.querySelector('.simple-search-close');
    const searchResults = searchPopup.querySelector('.simple-search-results');
    const statsButton = searchPopup.querySelector('.simple-search-stats-btn');
    
    // Posicionar popup cerca del icono
    function positionPopup() {
        const originalDisplay = searchPopup.style.display;
        searchPopup.style.display = 'flex';
        searchPopup.style.visibility = 'hidden';
        
        const iconRect = searchIcon.getBoundingClientRect();
        const popupWidth = searchPopup.offsetWidth;
        const popupHeight = searchPopup.offsetHeight;
        
        let top, left;
        
        if (GSEARCH_CONFIG.position.bottom) {
            top = window.innerHeight - parseFloat(GSEARCH_CONFIG.position.bottom) - popupHeight - 20;
        } else if (GSEARCH_CONFIG.position.top) {
            top = parseFloat(GSEARCH_CONFIG.position.top) + 60;
        } else {
            top = iconRect.top - popupHeight - 10;
        }
        
        if (GSEARCH_CONFIG.position.right) {
            left = window.innerWidth - parseFloat(GSEARCH_CONFIG.position.right) - popupWidth;
        } else if (GSEARCH_CONFIG.position.left) {
            left = parseFloat(GSEARCH_CONFIG.position.left);
        } else {
            left = iconRect.left - popupWidth + iconRect.width;
        }
        
        top = Math.max(10, Math.min(window.innerHeight - popupHeight - 10, top));
        left = Math.max(10, Math.min(window.innerWidth - popupWidth - 10, left));
        
        searchPopup.style.top = `${top}px`;
        searchPopup.style.left = `${left}px`;
        
        searchPopup.style.visibility = 'visible';
        if (originalDisplay !== 'flex') {
            searchPopup.style.display = originalDisplay;
        }
    }
    
    // Mostrar popup
    function showPopup() {
        positionPopup();
        searchPopup.style.display = 'flex';
        searchInput.focus();
    }
    
    // Ocultar popup
    function hidePopup() {
        searchPopup.style.display = 'none';
        searchInput.value = '';
        searchResults.innerHTML = '';
    }
    
    // Realizar búsqueda
    function performSearch() {
        const query = searchInput.value.trim();
        if (!query) return;
        
        searchResults.innerHTML = '<p>Buscando...</p>';
        
        const siteRestriction = GSEARCH_CONFIG.domains.map(domain => `site:${domain}`).join(' OR ');
        const searchQuery = `${query} (${siteRestriction})`;
        
        const url = `https://www.googleapis.com/customsearch/v1?key=${GSEARCH_CONFIG.googleApiKey}&cx=${GSEARCH_CONFIG.googleSearchEngineId}&q=${encodeURIComponent(searchQuery)}`;
        
        fetch(url)
            .then(response => response.json())
            .then(data => {
                displayResults(data);
                // saveSearchStats(query); // Comentado: estadísticas deshabilitadas
            })
            .catch(error => {
                searchResults.innerHTML = `<p>Error al realizar la búsqueda: ${error.message}</p>`;
                console.error('Error en la búsqueda:', error);
            });
    }
    
    // Mostrar resultados
    function displayResults(data) {
        if (!data.items || data.items.length === 0) {
            searchResults.innerHTML = '<p>No se encontraron resultados.</p>';
            return;
        }
        
        let resultsHtml = '';
        
        data.items.forEach(item => {
            const hasImage = item.pagemap && item.pagemap.cse_image && item.pagemap.cse_image.length > 0;
            const imageUrl = hasImage ? item.pagemap.cse_image[0].src : null;
            
            const shortSnippet = item.snippet.split(' ').slice(0, Math.ceil(item.snippet.split(' ').length / 2)).join(' ') + '...';
            
            resultsHtml += `
                <div class="simple-search-result">
                    ${imageUrl ? `<div class="simple-search-result-image">
                        <img src="${imageUrl}" alt="${item.title}" onerror="this.style.display='none'">
                    </div>` : ''}
                    <div class="simple-search-result-content">
                        <h3><a href="${item.link}">${item.title}</a></h3>
                        <div class="simple-search-result-url">${item.displayLink}</div>
                        <p>${shortSnippet}</p>
                    </div>
                </div>
            `;
        });
        
        searchResults.innerHTML = resultsHtml;
    }
    
    // Event listeners
    searchIcon.addEventListener('click', showPopup);
    searchClose.addEventListener('click', hidePopup);
    searchSubmit.addEventListener('click', performSearch);
    // statsButton.addEventListener('click', showSearchStats); // Comentado: estadísticas deshabilitadas
    
    searchInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            performSearch();
        }
    });
    
    // Cerrar popup al hacer clic fuera
    document.addEventListener('click', function(e) {
        if (!searchPopup.contains(e.target) && !searchIcon.contains(e.target) && searchPopup.style.display === 'flex') {
            hidePopup();
        }
    });
    
    // Reposicionar el popup al redimensionar la ventana
    window.addEventListener('resize', function() {
        if (searchPopup.style.display === 'flex') {
            positionPopup();
        }
    });
}
